// Catálogo centralizado de tipos de canal (id = "tipo" da tabela legacy)
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import StorefrontIcon from "@mui/icons-material/Storefront";
import WidgetsIcon from "@mui/icons-material/Widgets";
import MailIcon from "@mui/icons-material/Mail";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import ForumIcon from "@mui/icons-material/Forum";

export const CHANNEL_TYPES = {
  DEFAULT: 0,            // Canais genéricos / sem tipo definido
  TWILIO_PHONE: 5,
  WHATSAPP_QR: 6,
  MAILGUN: 9,
  FB_MESSENGER: 12,
  WHATSAPP_GUPSHUP: 20,
  IG_MESSENGER: 21,
  WHATSAPP_CLOUD: 24,
  // 6 reservado para WhatsApp QRCode
  TWILIO_SMS: 25,
  APP_IOS: 26,
  APP_ANDROID: 27,
  WORDPRESS: 28,
  PABX: 29,
  SMTP: 30,
  // Canal SMS unificado (provedores internos da plataforma)
  SMS: 31,
  // Alias legado (mantido por compat no frontend)
  CLICKATELL_SMS: 31,
  GOOGLE_ADS: 32,
  META_ADS: 33,
  // Novo tipo reservado p/ Ecommerce
  ECOMMERCE: 40,
  WEBSITE_VIACAO: 41,
  /** RCS Business — credenciais globais na infraestrutura; canal só com parâmetros de roteamento */
  RCS_BUSINESS: 42,
  /** @deprecated use CHANNEL_TYPES.RCS_BUSINESS */
  RCS_TWILIO: 42,
  // E-mail via SES (AWS) usando a conta Xpro
  EMAIL_AWS_SES: 35,
};

/** WhatsApp por sessão QR (não Cloud API): sem regra de janela de 24h / templates de reengajamento. */
export const isWhatsAppQrChannelTipo = (tipo) => Number(tipo) === CHANNEL_TYPES.WHATSAPP_QR;

export const CHANNEL_CARDS = [
  // ---- DEFAULT (genérico) ----
  {
    id: CHANNEL_TYPES.DEFAULT,
    key: "default",
    label: "Default",
    description: "Canal genérico (sem integrações específicas)",
    icon: (props) => <WidgetsIcon {...props} />,
  },

//   // ---- WhatsApp ----
//   {
//     id: CHANNEL_TYPES.WHATSAPP_CLOUD,
//     key: "whatsapp_cloud",
//     label: "WhatsApp Cloud API",
//     description: "Canal oficial Meta Business",
//     icon: (props) => <WhatsAppIcon {...props} />,
//     color: "#25D366",
//   },
  {
    id: CHANNEL_TYPES.WHATSAPP_GUPSHUP,
    key: "whatsapp_gupshup",
    label: "WhatsApp Cloud API",
    description:
      "WhatsApp Business Platform (Meta): mensagens, templates e fluxos pela API oficial hospedada.",
    icon: (props) => <WhatsAppIcon {...props} />,
    color: "#22C35E",
  },
  {
    id: CHANNEL_TYPES.WHATSAPP_QR,
    key: "whatsapp_qr",
    label: "WhatsApp (QR Code)",
    description: "Sessão pelo aplicativo via QR Code (não usa Cloud API).",
    icon: (props) => <WhatsAppIcon {...props} />,
    color: "#1FA855",
  },

  // ---- Social ----
  {
    id: CHANNEL_TYPES.FB_MESSENGER,
    key: "facebook_messenger",
    label: "Facebook Messenger",
    description: "Solicitações via Facebook",
    icon: (props) => <FacebookIcon {...props} />,
    color: "#1877F2",
  },
  {
    id: CHANNEL_TYPES.IG_MESSENGER,
    key: "instagram_messenger",
    label: "Instagram Direct",
    description: "Mensagens diretas do Instagram",
    icon: (props) => <InstagramIcon {...props} />,
    color: "#C13584",
  },

  // ---- E-mail ----
  {
    id: CHANNEL_TYPES.EMAIL_AWS_SES,
    key: "email_aws_ses",
    label: "E-mail",
    description: "Envio e recepção de e-mails diretamente pela plataforma, sem precisar configurar servidor de e-mail próprio.",
    icon: (props) => <MailIcon {...props} />,
  },
  // ---- Voz / Telefonia ----
  {
    id: CHANNEL_TYPES.PABX,
    key: "telephony",
    label: "Telefonia",
    description:
      "Integração com PABX para abrir solicitações automaticamente ao receber ligações.",
    icon: (props) => <PhoneIcon {...props} />,
  },
  {
    id: CHANNEL_TYPES.TWILIO_PHONE,
    key: "telephony_xpro",
    label: "Telefonia Xpro",
    description: "Telefonia integrada da plataforma para ligações e roteamento.",
    icon: (props) => <PhoneIcon {...props} />,
  },

  // ---- SMS ----
  {
    id: CHANNEL_TYPES.SMS,
    key: "sms",
    label: "SMS",
    description: "Envio e recebimento de SMS pela plataforma.",
    icon: (props) => <PhoneIcon {...props} />,
  },
  {
    id: CHANNEL_TYPES.RCS_BUSINESS,
    key: "rcs_business",
    label: "RCS Business",
    description:
      "Mensagens RCS enriquecidas. Credenciais e ambiente global ficam na plataforma; neste formulário configure apenas o que identifica este canal (endereços de receção e envio).",
    icon: (props) => <ForumIcon {...props} />,
    color: "#0063D3",
  },
//   {
//     id: CHANNEL_TYPES.SMTP,
//     key: "smtp",
//     label: "E-mail SMTP",
//     description: "Envio/Recepção via SMTP/IMAP",
//     icon: (props) => <MailIcon {...props} />,
//   },
//   {
//     id: CHANNEL_TYPES.MAILGUN,
//     key: "mailgun",
//     label: "E-mail Mailgun",
//     description: "Integração transacional",
//     icon: (props) => <MailIcon {...props} />,
//   },

//   // ---- Voz ----
//   {
//     id: CHANNEL_TYPES.PABX,
//     key: "pabx",
//     label: "Telefone PABX",
//     description: "Integração com PABX",
//     icon: (props) => <PhoneIcon {...props} />,
//   },

//   // ---- SMS ----
//   {
//     id: CHANNEL_TYPES.TWILIO_SMS,
//     key: "twilio_sms",
//     label: "SMS (legado)",
//     description: "Mensagens SMS via integração legada",
//     icon: (props) => <SmsIcon {...props} />,
//   },
//   {
//     id: CHANNEL_TYPES.CLICKATELL_SMS,
//     key: "clickatell_sms",
//     label: "SMS Clickatell",
//     description: "Mensagens SMS Clickatell",
//     icon: (props) => <SmsIcon {...props} />,
//   },

//   // ---- Apps ----
//   {
//     id: CHANNEL_TYPES.APP_IOS,
//     key: "ios",
//     label: "App iOS",
//     description: "Login e push via iOS",
//     icon: (props) => <AppleIcon {...props} />,
//   },
//   {
//     id: CHANNEL_TYPES.APP_ANDROID,
//     key: "android",
//     label: "App Android",
//     description: "Login e push via Android",
//     icon: (props) => <AndroidIcon {...props} />,
//   },

//   // ---- Web/Ads ----
//   {
//     id: CHANNEL_TYPES.WORDPRESS,
//     key: "wordpress",
//     label: "WordPress",
//     description: "Form/Widget no site WP",
//     icon: (props) => <LanguageIcon {...props} />,
//   },
//   {
//     id: CHANNEL_TYPES.GOOGLE_ADS,
//     key: "google_ads",
//     label: "Google Ads",
//     description: "Leads via Google Ads",
//     icon: (props) => <AdsClickIcon {...props} />,
//   },
//   {
//     id: CHANNEL_TYPES.META_ADS,
//     key: "meta_ads",
//     label: "Meta Ads",
//     description: "Leads via Meta Ads",
//     icon: (props) => <AdsClickIcon {...props} />,
//   },

  // ---- Ecommerce ----
  {
    id: CHANNEL_TYPES.ECOMMERCE,
    key: "ecommerce",
    label: "Ecommerce",
    description: "Pedidos, carrinho e webhooks",
    icon: (props) => <StorefrontIcon {...props} />,
  },
  {
    id: CHANNEL_TYPES.WEBSITE_VIACAO,
    key: "website_viacao",
    label: "Website Viação",
    description: "Website com URL temporária e domínio customizado",
    icon: (props) => <LanguageIcon {...props} />,
  },
];

export const findCardById = (id) =>
  CHANNEL_CARDS.find((c) => c.id === id) ||
  CHANNEL_CARDS.find((c) => c.id === CHANNEL_TYPES.DEFAULT);
